"use client";

import { Rarity } from "@/types/cat";
import { cn } from "@/lib/utils";

const rarities: { value: Rarity; label: string; color: string }[] = [
  { value: "common", label: "Common", color: "bg-slate-500" },
  { value: "rare", label: "Rare", color: "bg-blue-500" },
  { value: "legendary", label: "Legendary", color: "bg-purple-500" },
  { value: "mythic", label: "Mythic", color: "bg-amber-500" },
];

interface RarityFilterProps {
  selected: Rarity[];
  onChange: (selected: Rarity[]) => void;
}

export function RarityFilter({ selected, onChange }: RarityFilterProps) {
  const toggle = (rarity: Rarity) => {
    if (selected.includes(rarity)) {
      onChange(selected.filter((r) => r !== rarity));
    } else {
      onChange([...selected, rarity]);
    }
  };

  return (
    <div className="space-y-3">
      <h4 className="font-pixel text-xs text-muted-foreground">Rarity</h4>
      <div className="flex flex-wrap gap-2">
        {rarities.map((rarity) => {
          const isSelected = selected.includes(rarity.value);
          return (
            <button
              key={rarity.value}
              onClick={() => toggle(rarity.value)}
              className={cn(
                "flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-all",
                isSelected
                  ? "border-primary bg-primary/10 text-primary"
                  : "border-border bg-card text-muted-foreground hover:text-foreground"
              )}
            >
              <span className={cn("h-2.5 w-2.5 rounded-full", rarity.color)} />
              {rarity.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
